// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"cdef2381","345":"cda76214","370":"cb439db4","552":"ccab069a","722":"3fe14abf","910":"4648c6d2"}[chunkId] + ".chunk.js";
};